module.exports = {"520621001":"双江街道","520621002":"凯德街道","520621101":"闵孝镇","520621102":"太平镇","520621103":"坝盘镇","520621104":"民和镇","520621105":"桃映镇","520621106":"怒溪镇","520621202":"德旺土家族苗族乡","520621204":"官和侗族土家族苗族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520621.json
// module id = 2627
// module chunks = 0